import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { miscellaneous } from "../../../lib/misc";

export default function TotalExceptions() {
    const [totals, setTotals] = useState(0)
    const selectedExceptions = useSelector(state => state.filter.exceptions)
    useEffect(() => {       
 
        if (selectedExceptions && selectedExceptions.case_flags && Object.keys(selectedExceptions?.case_flags).length) {   

            let number = 0

            number = miscellaneous.numberOfObjectValues(selectedExceptions.case_flags)

            setTotals(number)
        } else {
            setTotals(0)
        }
    }, [selectedExceptions])

    return <>
        {totals}
    </>
}